import React from "react";
import EssentialFeaturesList from "./components/EssentialFeaturesList";
import ShieldLeft from "../../assets/images/shield-check_left.png";

export default function EssentialFeatures() {
  return (
    <div className="relative">
      <section className="container mx-auto py-[40px] md:py-[85px] 2xl:py-[160px]">
        <div className="mb-[16px] md:mb-[45px] 2xl:mb-[80px]">
          <h1 className="mb-[18px] text-center font-manrope text-[20px] font-extrabold leading-[28px] text-[#333333] md:text-[26px] md:font-[800] md:leading-[36px] 2xl:text-[34px] 2xl:leading-[46px]">
            Why Choose Geo VPN?
          </h1>

          <p className="text-center font-manrope text-[13px] font-semibold leading-[18px] text-[#666A7C] md:text-[15px] md:font-[600] md:leading-[22px] 2xl:text-[18px] 2xl:leading-[26px]">
            Discover How Geo VPN Enhances Your Online Experience with{" "}
            <br className="hidden md:inline-block" />
            Unmatched Privacy, Speed, and Freedom.
          </p>
        </div>
        <EssentialFeaturesList />
      </section>
      <img
        src={ShieldLeft}
        alt="shield img"
        className="absolute left-0 hidden md:top-[5%] md:block md:h-[266.28px] 2xl:top-[10%] 2xl:h-auto 2xl:w-[200px]"
      />
    </div>
  );
}
